import { jsx as n } from "react/jsx-runtime";
import { useTheme as m, useMediaQuery as p } from "@mui/material";
import { TEST_IDS as c } from "./testIds.mjs";
import { AcceptPoliciesDialog as d } from "./index240.mjs";
import { AcceptPoliciesDrawer as l } from "./index241.mjs";
const A = (e) => {
  const {
    isPreview: t,
    locale: i,
    onAgreeClick: o,
    onLogOutClick: r,
    isAgreeButtonLoading: s
  } = e, a = m();
  return p(
    a.breakpoints.up("sm")
  ) ? /* @__PURE__ */ n(
    d,
    {
      locale: i,
      onAgreeClick: o,
      onLogOutClick: r,
      isAgreeButtonLoading: s,
      isPreview: !!t,
      testId: e["data-testid"] ?? c.cookiesConsent
    }
  ) : /* @__PURE__ */ n(
    l,
    {
      locale: i,
      onAgreeClick: o,
      onLogOutClick: r,
      isAgreeButtonLoading: s,
      isPreview: !!t,
      testId: e["data-testid"] ?? c.cookiesConsent
    }
  );
};
export {
  A as AcceptPolicies
};
//# sourceMappingURL=index136.mjs.map
